export default {
  cmpId: '10-051342',
  cmpName: 'residential_realtordirectory',
  cmpPosition: 'residential_atlas_home',
  cmpCreative: 'touchpoint_atlas_home',
};
